/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Currentprice1Inputs */

const he_item_stats_currentprice1 = /** @type {(inputs: Item_Stats_Currentprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר נוכחי`)
};

const en_item_stats_currentprice1 = /** @type {(inputs: Item_Stats_Currentprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current price`)
};

/**
* | output |
* | --- |
* | "Current price" |
*
* @param {Item_Stats_Currentprice1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_currentprice1 = /** @type {((inputs?: Item_Stats_Currentprice1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Currentprice1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_currentprice1(inputs)
	return en_item_stats_currentprice1(inputs)
});
export { item_stats_currentprice1 as "item_stats_currentPrice" }